require('@babel/register')()

module.exports = require('./src/gatsby/gatsby-browser')
